import './scripts/common';
import './scripts/common-nav';

let _config = window['_config'] || {};

// @ts-ignore
window.app = window['app'] || {
    debug: false,
};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as fadeIn from './scripts/fade-in';
fadeIn.init();

import * as shariff from './scripts/shariff';
shariff.init();

